import { twMerge } from 'tailwind-merge';
import type { ProjectStatusId } from '@witmetrics/utils';
import { findById } from '@witmetrics/utils/arrays';
import { PROJECT_STATUSES } from '@witmetrics/utils/constants';
import { PROJECT_STATUS_COLORS } from '@witmetrics/unison-core';
import { STATUS_TINT } from './constants';
import { classes } from './utils';

export type ProjectStatusChipProps = {
  className?: string;
  projectStatusId: ProjectStatusId;
};

export default function ProjectStatusChip({
  className,
  projectStatusId,
}: ProjectStatusChipProps) {
  const status = findById(Object.values(PROJECT_STATUSES), projectStatusId)!;
  const color = PROJECT_STATUS_COLORS[projectStatusId];

  return (
    <span
      className={twMerge(
        classes.pill,
        STATUS_TINT[color.bg],
        color.text,
        className
      )}>
      <span className={twMerge(classes.dot, color.bg)} />
      {status.label}
    </span>
  );
}
